import { useTableContext } from 'lib/context/TableContext/TableContext';

import Modal from 'components/shared/Modal/Modal';

import TreatmentPlanTable from './TreatmentPlanTable';

const TreatmentPlanModalTable = ({
  setShowAllRowsTable = () => {},
  showAllRowsTable = false,
  treatmentPlan = [],
  fromPracticeIQueue,
  showMultiActions = false,
  onCellClicked = () => {}
}) => {
  const { selectedRows, setSelectedRows } = useTableContext();
  return (
    <Modal
      handleOpen={showAllRowsTable && !fromPracticeIQueue}
      className="w-[91%] bg-white sm:w-[96%] md:w-[96%] lg:w-[96%] xxl:max-w-[1920px]"
      bodyClassName="p-0"
      title="Treatment Plans"
      slideFromRight
      handleClose={() => {
        setSelectedRows([]);
        setShowAllRowsTable(false);
      }}>
      <TreatmentPlanTable
        selectedRows={selectedRows}
        data={treatmentPlan}
        showMultiActions={showMultiActions}
        onCellClicked={onCellClicked}
      />
    </Modal>
  );
};
export default TreatmentPlanModalTable;
